import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Grid, Button } from '@mui/material';
import { IoClose } from "react-icons/io5";
import { IoIosAddCircleOutline } from "react-icons/io";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import SnackbarAlert from '../../common/SnackbarAlert';
import { RiAddCircleLine, RiCheckLine, RiEdit2Line, RiErrorWarningLine } from "react-icons/ri";

const BenefitsModal = ({
  open,
  handleClose,
  addToBenefitsList,
  editBenefit,
  asyncTier,
  benefitsList,
  removePaidMessageBenefit,
  removeFromBenefitsList,
  isEditing,
  replaceWithCustomBenefit,
  replaceBenefit,
  customBenefitName,
  handleCustomBenefitName,
  paidMessagesBenefitTotal,
  handlePaidMessagesBenefitTotal,
  paidMessagesTitleType,
  handlePaidMessagesTitleType,
}) => {
  const { t } = useTranslation();
  const [mode, setMode] = React.useState('custom');
  const [secondaryModal, setSecondaryModal] = React.useState(false);
  const [errorVisible, setErrorVisible] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');



  useEffect(() => {
    if (customBenefitName.length > 30) {
      setErrorVisible(true);
      setErrorMessage(t('dashboard.benefits.maxCharsError'));
    }
  }, [customBenefitName]);


  // Fetch benefit arrays from i18n locale files
  const membershipBenefitsData = t('dashboard.benefits.benefitOptions.membership', { returnObjects: true });
  const asyncBenefitsData = t('dashboard.benefits.benefitOptions.async', { returnObjects: true });
  const paidMessageTitlesData = t('dashboard.benefits.benefitOptions.paidMessageTitles', { returnObjects: true });

  // Ensure arrays are valid, fallback to empty arrays if not found
  const membershipBenefits = Array.isArray(membershipBenefitsData) ? membershipBenefitsData : [];
  const asyncBenefits = Array.isArray(asyncBenefitsData) ? asyncBenefitsData : [];

  const paidMessageTitlesPlural = Array.isArray(paidMessageTitlesData?.plural) ? paidMessageTitlesData.plural : [];
  const paidMessageTitlesSingular = Array.isArray(paidMessageTitlesData?.singular) ? paidMessageTitlesData.singular : [];

  const checkForPlural = paidMessagesBenefitTotal > 1 ? paidMessageTitlesPlural : paidMessageTitlesSingular;

  const benefitsToDisplay = asyncTier ? asyncBenefits : membershipBenefits;

  // Get translated names for special benefits by index (index 0 = custom benefit, index 1 = paid messages)
  const translatedCustomBenefitName = membershipBenefits.length > 0 ? membershipBenefits[0].name : '';
  const translatedPaidMessagesName = membershipBenefits.length > 1 ? membershipBenefits[1].name : '';

  const paidMessageTitles = [
    ...paidMessageTitlesPlural,
    ...paidMessageTitlesSingular,
  ]

  return (
    <>
      <Modal hideBackdrop open={open} onClose={handleClose}
        sx={{
          zIndex: '9999', overflow: 'auto', backgroundColor: 'transparent',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}>

        <div style={{ backgroundColor: 'white', maxWidth: '600px', paddingBottom: '20px', margin: '0px auto', marginTop: '5%', marginBottom: '5%', overflow: 'auto', borderRadius: window.innerWidth > 600 ? '10px' : '0px', }}>

          <Grid container
            style={{
              width: '90%',
              justifyContent: "center",
              alignItems: "center",
              height: 'auto',
              margin: '20px auto 10px auto',
              maxHeight: "2000px",
              display: "flex",
            }}>
            <Grid lg={11} xs={11}>
              {isEditing === true ? <h3>{t('dashboard.benefits.editBenefitsTitle', { count: benefitsList.length })}{asyncTier === true ? t('onboarding.yourOfferingModal.oneOnOneSupportSuffix') : ''}</h3> : <h3>{t('dashboard.benefits.addBenefitsTitle', { count: benefitsList.length })}{asyncTier === true ? t('onboarding.yourOfferingModal.oneOnOneSupportSuffix') : ''}</h3>}
            </Grid>
            <Grid lg={1} xs={1}
              style={{
                top: '0px',
                padding: '0px',
                float: 'right',
                textAlign: 'right',
              }}
            >
              <div style={{ '&:hover': { cursor: 'pointer' } }}>
                <a onClick={() => { handleClose(); }}>
                  <IoClose className={'modal-close-icon'} style={{ width: '25px', height: '25px' }} />
                </a>
              </div>
            </Grid>
          </Grid>

          <div style={{
            backgroundColor: '#D3DCE7',
            marginTop: '0px',
            width: '90%',
            height: '1px',
            marginBottom: '10px',
            margin: '10px auto',
            padding: '0px 0px'
          }} />

          {benefitsToDisplay.map((benefit) => {
            const isCustomBenefit = benefit.name === translatedCustomBenefitName;
            const isPaidMessagesBenefit = benefit.name === translatedPaidMessagesName;
            // Use translated paid message titles as keywords to identify paid message benefits
            const paidMessagesKeywords = [
              ...paidMessageTitlesPlural,
              ...paidMessageTitlesSingular
            ];
            
            const isPaidMessagesUsed = benefitsList.some(existingBenefit =>
              paidMessagesKeywords.some(keyword => existingBenefit.name.includes(keyword))
            );


  const isSelected = benefitsList.some(existingBenefit => existingBenefit.name === benefit.name);          

  // Determine if the button should be disabled
  const isDisabled = 
  benefitsList.length >= 4 
  // ||
  // (!isCustomBenefit && (
  //   (isEditing && editBenefit !== 'Paid messages' && isPaidMessagesBenefit) ||
  //   (isPaidMessagesBenefit && isPaidMessagesUsed && !isEditing) ||
  //   (!isPaidMessagesBenefit && isSelected)
  // ));
  

  const buttonLabel = 
  (isEditing && editBenefit === benefit.name) ? 'Current' :
  (isPaidMessagesBenefit && isPaidMessagesUsed) ? 'Remove' :
  (isEditing && isPaidMessagesBenefit) ? 'Edit' :
  (editBenefit === benefit.name) ? 'Current' :
  (benefitsList.length >= 4 && !isSelected) ? 'Max Benefits' :
  (isDisabled || isSelected) ? 'Remove' :
  'Add';





  
  return (
    <Grid container key={benefit.name} sx={{ marginBottom: '10px', width: '90%', margin: 'auto', padding: '20px 0px' }}>
      <Grid xs={9}>
        <h4 style={{ margin: '0px 0px 10px 0px' }}>{benefit.name === translatedPaidMessagesName ? t('dashboard.benefits.messages') : benefit.name} {benefit.name === translatedPaidMessagesName ? <span style={{ color: 'var(--brand-color)', verticalAlign: 'text-bottom', fontSize: '14px', margin: '0px 0px 0px 7px' }}>{t('dashboard.benefits.new')}</span> : ''}</h4>
        <p style={{ color: '#6D89AF', fontSize: '14px', margin: '0px 0px 0px 0px' }}>{benefit.description}</p>
      </Grid>
      <Grid xs={3} style={{ display: 'flex', alignItems: 'right', justifyContent: 'right', height: 'max-content' }}>
        <Button
          disabled={isDisabled && !isSelected}
          sx={{
            color: '#fff',
            // backgroundColor: isDisabled ? "#F5F9FF" : "var(--brand-color)",
            backgroundColor: buttonLabel === 'Remove' ? '#fff': (isDisabled && !isSelected) ? "#fff" : 'var(--brand-color)',
            color: buttonLabel === 'Remove' ? 'var(--brand-color)': (isDisabled && !isSelected) ? "var(--brand-color)" : '#fff',
            border: (isDisabled && !isSelected) ? '1.5px solid #BDBDBD' : '1.5px solid var(--brand-color)',
            fontFamily: 'roboto',
            fontWeight: '500',
            fontSize: '13px',
            borderRadius: '8px',
            '&:hover': {
              border: (isDisabled && !isSelected) ? '1.5px solid var(--brand-color-hover' : '1.5px solid var(--brand-color)',
              backgroundColor: buttonLabel === 'Remove' ? 'var(--brand-color-hover)' : 'var(--brand-color-hover)',
              color: buttonLabel === 'Remove' ? '#fff' : "#fff",
            }
          }}
          onClick={() => {

            if (buttonLabel === 'Remove' && benefit.name === translatedPaidMessagesName) {
              removePaidMessageBenefit(benefit.name);
            } else if (buttonLabel === 'Remove') {
              removeFromBenefitsList(benefit.name);
            } 
            else {
              if (isEditing) {
                if (isCustomBenefit) {
                  setMode(benefit.name);
                  setSecondaryModal(true);
                } else if (isPaidMessagesBenefit) {
                  setMode(benefit.name);
                  setSecondaryModal(true);
                } else {
                  replaceBenefit(editBenefit, benefit.name);
                  // handleClose();
                }
              } else {
                if (isPaidMessagesBenefit || isCustomBenefit) {
                  setMode(benefit.name);
                  setSecondaryModal(true);
                } else {
                  addToBenefitsList(benefit.name);
                  // handleClose();
                }
              }
            }
          }}
        >
          {
            buttonLabel === 'Remove' ?
              <RiAddCircleLine style={{ fontSize: '13px', margin: '4.5px 3px auto 0px', rotate: '45deg' }} /> :
              (buttonLabel === 'Max Benefits' || buttonLabel === 'Current') ? <RiErrorWarningLine style={{ fontSize: '13px', margin: '4.5px 3px auto 0px' }} /> :
                <RiAddCircleLine style={{ fontSize: '13px', margin: '4.5px 3px auto 0px' }} />
          }

          {buttonLabel === 'Remove' ? t('dashboard.benefits.remove') :
            buttonLabel === 'Current' ? t('dashboard.benefits.current') :
            buttonLabel === 'Edit' ? t('common.edit') :
            buttonLabel === 'Max Benefits' ? t('dashboard.benefits.maxBenefits') :
            buttonLabel === 'Add' ? t('dashboard.benefits.add') : buttonLabel}
        </Button>
      </Grid>


      
    </Grid>
  )
})}
<div style={{ display: 'flex', width: '100%' }}>


<Button fullWidth

                  onClick={() => {
                    handleClose();
                    
                  }


                  } disableElevation
                  sx={{
                    padding: '5px 25px',
                    width: '90%',
                    textAlign: 'center',
                    display: 'inline-block',
                    color: '#fff',
                    margin: '20px auto 15px auto',
                    borderRadius: '10px',
                    textTransform: 'none',
                    border: '2px var(--brand-color) solid',
                    backgroundColor: 'var(--brand-color)',
                    '&:hover': {
                      color: '#fff',
                      backgroundColor: 'var(--brand-color-hover)',
                      border: '2px var(--brand-color-hover) solid',
                    }
                  }}>
                  <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '16px' }}>{t('dashboard.benefits.finishedAddingBenefits')}</span>
                </Button>
                </div>


          <p style={{ color: '#6D89AF', fontSize: '14px', margin: '15px 0px 15px 0px', textAlign: 'center' }}>{t('dashboard.benefits.cantFindPrompt')} <span onClick={() => { setMode('Custom benefit - write your own'); setSecondaryModal(true); }} style={{ color: 'var(--brand-color)', textDecoration: 'underline', cursor: 'pointer' }}>{t('dashboard.benefits.addYourOwn')}</span></p>
        </div>
      </Modal>

      <Modal open={secondaryModal} onClose={handleClose} sx={{ zIndex: '9999', overflow: 'auto', backgroundColor: 'rgba(0, 0, 0, 0.5)', }}>
        <div style={{ minHeight: '100vh', height: '100%', width: '100%', display: 'flex' }}>

          <div style={{ backgroundColor: 'white', maxWidth: '450px', minWidth: '320px', width: '100%', paddingBottom: '20px', margin: 'auto', overflow: 'auto', borderRadius: window.innerWidth > 600 ? '10px' : '0px', }}>

            <Grid container
              style={{
                width: '90%',
                justifyContent: "center",
                alignItems: "center",
                height: 'auto',
                margin: '20px auto 10px auto',
                maxHeight: "2000px",
                display: "flex",
              }}>
              <Grid lg={11} xs={11}>
                {mode === translatedPaidMessagesName ? <h3>{t('dashboard.benefits.messages')}</h3> : <h3>{t('dashboard.benefits.customBenefit')}</h3>}
              </Grid>
              <Grid lg={1} xs={1}
                style={{
                  top: '0px',
                  padding: '0px',
                  float: 'right',
                  textAlign: 'right',
                }}>
                <div style={{ '&:hover': { cursor: 'pointer' } }}>
                  <a onClick={() => { setSecondaryModal(false); }}>
                    <IoClose className={'modal-close-icon'} style={{ width: '25px', height: '25px' }} />
                  </a>
                </div>
              </Grid>
            </Grid>

            <div style={{
              backgroundColor: '#D3DCE7',
              marginTop: '0px',
              width: '90%',
              height: '1px',
              marginBottom: '10px',
              margin: '10px auto',
              padding: '0px 0px'
            }} />

            <>
              {mode !== translatedPaidMessagesName ?
                <>
                  <Grid container sx={{ width: '90%', margin: 'auto' }}>
                    <p className={'modal-title-text'} style={{ fontSize: '15px', margin: '20px 0px 10px 0px' }}>{t('dashboard.benefits.benefitName')}</p>
                    <input
                      type="text"
                      // maxLength={30}
                      className={'text-input'}
                      id={"tierPerksText"}
                      value={customBenefitName}
                      style={{
                        display: 'block',
                        fontWeight: '400',
                        margin: '0px auto 7px auto',
                        fontSize: '16px',
                        padding: '13px 15px',
                        color: '#1D1D1D',
                        borderRadius: '5px',
                        width: 'calc(100% - 30px)',
                        fontFamily: 'Roboto',
                      }}
                      placeholder={t('dashboard.benefits.enterPerkPlaceholder')}
                      onChange={(event) => {
                        if (event.target.value.length <= 30) {
                          handleCustomBenefitName(event.target.value);
                          setErrorVisible(false);
                          setErrorMessage('');
                        } else {
                          handleCustomBenefitName(event.target.value);
                          setErrorVisible(true);
                          setErrorMessage(t('dashboard.benefits.maxCharsError'));
                        }
                        // handleCustomBenefitName(event.target.value);
                      }}
                    />
                  </Grid>
                </>
                :
                <>
                  <Grid container sx={{ width: '90%', margin: 'auto' }}>
                    <Grid xs={12} sx={{}}>
                      <p className={'modal-title-text'} style={{ fontSize: '15px', margin: '20px 0px 10px 0px' }}>{t('dashboard.benefits.noOfMessages')}</p>
                      <input
                        type="text"
                        className={'text-input'}
                        id={"tierPerksText"}
                        value={paidMessagesBenefitTotal}
                        style={{
                          display: 'block',
                          fontWeight: '400',
                          margin: '0px auto 7px auto',
                          fontSize: '16px',
                          padding: '13px 15px',
                          color: '#1D1D1D',
                          borderRadius: '5px',
                          width: 'calc(100% - 30px)',
                          fontFamily: 'Roboto',
                        }}
                        placeholder={t('dashboard.benefits.enterMessagesPlaceholder')}
                        onChange={(event) => {
                          const newValue = event.target.value;
                          const numValue = parseInt(newValue);
                          
                          // Always update the value first
                          handlePaidMessagesBenefitTotal(newValue);
                          
                          // Handle switching between singular and plural dropdown options
                          const currentIsSingular = paidMessagesBenefitTotal == 1;
                          const newIsSingular = numValue == 1;
                          
                          if (currentIsSingular !== newIsSingular && paidMessagesTitleType) {
                            // Find the corresponding singular/plural form
                            const currentIndex = currentIsSingular 
                              ? paidMessageTitlesSingular.indexOf(paidMessagesTitleType)
                              : paidMessageTitlesPlural.indexOf(paidMessagesTitleType);
                              
                            if (currentIndex !== -1) {
                              const newTitleType = newIsSingular 
                                ? paidMessageTitlesSingular[currentIndex]
                                : paidMessageTitlesPlural[currentIndex];
                              handlePaidMessagesTitleType(newTitleType);
                            }
                          }
                          
                          // Validation
                          if (isNaN(numValue) || numValue < 1 || numValue > 100) {
                            setErrorVisible(true);
                            setErrorMessage(t('dashboard.benefits.numberRangeError'));
                          } else {
                            setErrorVisible(false);
                            setErrorMessage('');
                          }
                        }}
                      />
                    </Grid>


                    <Grid xs={12} sx={{ marginBottom: '7px' }}>
                      <p className={'modal-title-text'} style={{ fontSize: '15px', margin: '20px 0px 10px 0px' }}>{t('dashboard.benefits.selectTypeOfMessages')}</p>
                      <Select
                        sx={{
                          maxHeight: '48px', minHeight: '48px', backgroundColor: 'white', zIndex: '9999',
                          width: '100%',
                          margin: 'auto',
                        }}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={paidMessagesTitleType}
                        onChange={(e) => {
                          handlePaidMessagesTitleType(e.target.value);
                        }}
                        MenuProps={{ style: { zIndex: '9999' } }}
                      >
                        {checkForPlural.map((item) => {
                          return (
                            <MenuItem value={item} sx={{ textAlign: 'left' }}>
                              {item}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </Grid>
                  </Grid>
                </>
              }

              <Grid container sx={{ width: '90%', margin: 'auto' }}>
                <Button fullWidth
                  disabled={
                    (mode === translatedCustomBenefitName && (customBenefitName.length <= 0 || customBenefitName.length > 30)) ||
                    (mode === translatedPaidMessagesName && (isNaN(parseInt(paidMessagesBenefitTotal)) || parseInt(paidMessagesBenefitTotal) < 1 || parseInt(paidMessagesBenefitTotal) > 100))
                  }
                  onClick={() => {

                    if ((mode === translatedCustomBenefitName && customBenefitName.length > 0 && customBenefitName.length <= 30) || mode === translatedPaidMessagesName && paidMessagesBenefitTotal > 0 && paidMessagesBenefitTotal <= 100) {
                      if (isEditing === true && mode === translatedCustomBenefitName) {
                        replaceWithCustomBenefit(editBenefit, mode);
                        setSecondaryModal(false);
                        // handleClose();
                      }
                      else if (isEditing === true && mode === translatedPaidMessagesName) {
                        replaceBenefit(editBenefit, mode);
                        setSecondaryModal(false);
                        // handleClose();
                      } else {
                        addToBenefitsList(mode);
                        setSecondaryModal(false);
                        // handleClose();
                      }
                    } else {
                      if (customBenefitName.length <= 0) {
                        setErrorVisible(true);
                        setErrorMessage(t('dashboard.benefits.enterBenefitNameError'));
                      } else if (customBenefitName.length > 30) {
                        setErrorVisible(true);
                        setErrorMessage(t('dashboard.benefits.maxCharsError'));
                      } else if (paidMessagesBenefitTotal <= 0) {
                        setErrorVisible(true);
                        setErrorMessage(t('dashboard.benefits.invalidNumberMessagesError'));
                      } else if (paidMessagesBenefitTotal > 100) {
                        setErrorVisible(true);
                        setErrorMessage(t('dashboard.benefits.numberRangeError'));
                      } else {
                        setErrorVisible(true);
                        setErrorMessage(t('dashboard.benefits.invalidInputError'));
                      }
                    }
                  }


                  } disableElevation
                  sx={{
                    padding: '5px 25px',
                    width: '100%',
                    textAlign: 'center',
                    display: 'inline-block',
                    color: '#fff',
                    margin: '20px 0px 15px 0px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    border: '2px var(--brand-color) solid',
                    backgroundColor: 'var(--brand-color)',
                    '&:hover': {
                      color: '#fff',
                      backgroundColor: 'var(--brand-color-hover)',
                      border: '2px var(--brand-color-hover) solid',
                    },
                    '&:disabled': {
                      backgroundColor: '#f5f5f5',
                      color: '#bdbdbd',
                      border: '2px #e0e0e0 solid',
                    }
                  }}>
                  <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '16px' }}>{t('onboarding.yourOfferingModal.addBenefit')}</span>
                </Button>
              </Grid>

              {errorVisible ?
                <div style={{ color: 'var(--danger-color)', fontWeight: '600', fontSize: '12px', textAlign: 'center' }}>
                  {errorMessage}
                </div>
                : null}
            </>
          </div>
        </div>
      </Modal>



    </>
  );
};

export default BenefitsModal;